export enum DrawerStep {
  SelectApp = 'SelectApp',
  SelectMarketWidget = 'SelectMarketWidget',
  SelectSpotChart = 'SelectSpotChart',
  SelectFWDChart = 'SelectFWDChart',
  SelectBasicDataTable = 'SelectBasicDataTable',
  SelectHighlightedPrice = 'SelectHighlightedPrice',
  SpotHistoryTable = 'SpotHistoryTable'
}
